import fetch from '../../lib/wrappedFetch'
import config from '../../config'

class CustomerUserRelationshipsService {
  deleteCustomerUserRelationship = (params) => {
    return fetch(config.config.endpointUrls.deleteCustomerUserRelationship(params), {
      method: 'DELETE'
    })
  }
}

export default new CustomerUserRelationshipsService()



// WEBPACK FOOTER //
// ../src/services/customerUserRelationshipsService/customerUserRelationshipsService.js